import React, { Component } from 'react'
import style from './index.module.less'
import { observer } from 'mobx-react'
import { Checkbox, Input } from 'hljd'
const { Search } = Input

@observer
class Index extends Component {
  componentDidMount() {
    document.addEventListener('click', this.hideMenu)
  }
  hideMenu = () => {
    this.props.store.hideKeZhao()
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.hideMenu)
  }
  handleClick = e => {
    e.nativeEvent.stopImmediatePropagation()
  }
  render() {
    const { store } = this.props
    const { kezhaoList, tempIds, hideOhterKeZhao } = store
    return (
      <div className={style.editWrap} onClick={this.handleClick}>
        <div className={style.titleWrap}>
          <div className={style.title}>关联客照</div>
          <div className={style.titleRight}>
            <Checkbox
              checked={hideOhterKeZhao}
              onChange={() =>
                store.setStoreData('hideOhterKeZhao', !hideOhterKeZhao)
              }
            >
              仅看已关联的客照
            </Checkbox>
            <span className={style.refresh}>刷新</span>
          </div>
        </div>
        <div className={style.searchWrap}>
          <Search
            placeholder="输入客照名"
            onSearch={value => store.getKeZhaoList(value)}
          />
        </div>
        <ul className={style.listWrap}>
          {kezhaoList.map((item, index) => {
            const isChecked = tempIds.find(temp => item.id == temp)
            if (hideOhterKeZhao && !isChecked) {
              return null
            }
            return (
              <li
                className={style['img-list-item']}
                onClick={() => store.onTempClick(item)}
                key={index}
              >
                <div className={style['img-content']}>
                  <img
                    src={`${item.coverPath ||
                      item.cover_path}?imageView2/1/w/180/h/112`}
                  />
                </div>
                <p className={style.photoTitle} title={item.title}>
                  {item.title}
                </p>
                <div className={style.status}>
                  <Checkbox checked={isChecked} />
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

export default Index
